import styled, { css } from 'styled-components';

interface StyledPopoverProps {
    $isOpening?: boolean;
    $isOpen?: boolean;
    $popperSize?: 'auto' | 'sm' | 'md' | 'lg' | 'xl' | string;
}

const setSize = (size: 'auto' | 'sm' | 'md' | 'lg' | 'xl' | string) => {
    switch (size) {
        case 'sm':
            return css`
                width: 100px;
            `;
        case 'md':
            return css`
                width: 200px;
            `;
        case 'lg':
            return css`
                width: 275px;
            `;
        case 'xl':
            return css`
                width: 348px;
            `;
        case 'auto':
        default:
            return css`
                width: ${size ? size : 'auto'};
                ${size ? `max-width: ${size}` : ''}
            `;
    }
};

export const StyledPopover = styled.div<StyledPopoverProps>`
    background-color: white;
    box-shadow: 0px 0px 1px rgba(0, 0, 0, 0.2), 0px 4px 8px rgba(0, 0, 0, 0.1);
    padding: 16px;
    border-radius: 6px;
    ${({ $popperSize }) => setSize($popperSize || 'auto')}
    max-width: 350px;
    opacity: 1;
    display: ${({ $isOpen }) => ($isOpen ? 'block' : 'none')};
    transition: opacity 0.2s ease-in-out;
    ${({ $isOpening }) =>
        $isOpening &&
        css`
            opacity: 1;
        `}

    &[data-popper-reference-hidden="true"] {
        visibility: hidden;
        pointer-events: none;
    }
    z-index: 3;
`;

export const StyledPopoverTitle = styled.div`
    font-size: 16px;
    font-weight: 600;
    margin-bottom: 8px;
`;
